import SlovakRoundSvg from '~/@ui/_sharedSvgs/flags/SlovakiaRound.svg?react'
import CzechRoundSvg from '~/@ui/_sharedSvgs/flags/CzechRound.svg?react'

export interface PhoneCountry {
  code: string
  flag: JSX.Element
  name: string
}

export const getPhoneCountries = () => {
  const countries: PhoneCountry[] = [
    {
      code: '+421',
      flag: <SlovakRoundSvg className="w-6 h-6" />,
      name: 'Slovensko',
    },
    {
      code: '+420',
      flag: <CzechRoundSvg className="w-6 h-6" />,
      name: 'Česká republika',
    },
  ]

  const getCountryByCode = (code: string) =>
    countries.find((country) => country.code === code)

  return {
    countries,
    getCountryByCode,
  }
}
